import { BaseModel } from './BaseModel';

export class Product extends BaseModel {
  hydrate(data) {
    this.typeName = data.name ? data.name : null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
